import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router/index";
import { applyTheme, resolveInitialTheme } from "./utils/theme";
import { initializeLocale, installI18n } from "./i18n";

// Material Symbols — lokal (offline-ready). CSS + woff2 di-load langsung dari public/ via <link> di index.html agar tidak FOUT & tidak di-bundle ulang.
// Inter & Epilogue — lokal via @fontsource (offline-ready, lebih cepat dari Google Fonts CDN).
import "@fontsource/inter/latin-300.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/inter/latin-800.css";
import "@fontsource/epilogue/latin-300.css";
import "@fontsource/epilogue/latin-400.css";
import "@fontsource/epilogue/latin-500.css";
import "@fontsource/epilogue/latin-600.css";
import "@fontsource/epilogue/latin-700.css";
import "@fontsource/epilogue/latin-800.css";

// Admin theme CSS — langsung di-bundle (bukan lazy-load)
import "./assets/css/tailwind.css";
import "./assets/scss/bootstrap-lite.scss";
import "./assets/css/sidebar-menu.css";
import "./assets/css/simplebar.css";
import "./assets/scss/style.scss";

const app = createApp(App);
initializeLocale();
installI18n(app);
app.use(createPinia());
app.use(router);
router.isReady().then(() => {
	// Terapkan tema sebelum mount supaya tidak ada flash warna terang.
	applyTheme(resolveInitialTheme(), false);
	app.mount("#app");
});
